(function () {
  'use strict';

  var state = {
    currentStep: 0,
    answers: { q1: [], q2: null, q3: null, q4: null, q5: null },
    result: null
  };

  // ── Scoring maps (Q1–Q3 inform personalisation; Q4 decides need) ──────────────
  var Q1_SCORES = {
    A: { CULTIVATE: 1, RITUAL: 1 },
    B: { SOW: 1, RITUAL: 1 },
    C: { SOW: 1 },
    D: { CULTIVATE: 2 },
    E: { RITUAL: 1 }
  };
  var Q2_SCORES = {
    A: { CULTIVATE: 2 },
    B: { SOW: 3 },
    C: { SOW: 3 },
    D: { RITUAL: 2 },
    E: { RITUAL: 1 }
  };
  var Q3_SCORES = {
    A: { SOW: 3 },
    B: { CULTIVATE: 3 },
    C: { RITUAL: 3 },
    D: { RITUAL: 3 },
    E: { RITUAL: 2 }
  };

  // Q4 is a direct stated need — absolute authority when answered
  var Q4_NEED = {
    A: 'SOW',
    B: 'CULTIVATE',
    C: 'RITUAL',
    D: 'RITUAL'
  };

  // ── Personalised intro copy ───────────────────────────────────────────────────
  function getPersonalisedIntro(need, q4, q3, q2, q5) {
    if (need === 'SOW') {
      if (q4 === 'A') return "You told us cleansing is the part of your routine you'd most like to change, and you're looking for a gentler, more comfortable way to cleanse. That's why we'd begin with SOW.";
      if (q2 === 'B' || q2 === 'C') return "You told us your skin can feel tight, dry or unsettled after cleansing, and you'd like your routine to feel more comfortable. That's why we'd begin with SOW.";
      return "You told us you're looking for a gentler, more comfortable cleanse. That's why we'd begin with SOW.";
    }
    if (need === 'CULTIVATE') {
      if (q4 === 'B') return "You told us your cleansing routine is working for you, but you're looking for more nourishment and softness as your skin changes. That's why we'd begin with CULTIVATE.";
      return "You told us you're noticing changes in texture or fine lines and would like more replenishing care, without adding unnecessary steps. That's why we'd begin with CULTIVATE.";
    }
    if (need === 'RITUAL') {
      if (q4 === 'D') return "You told us you've tried plenty but still aren't quite sure what your skin needs, and you'd like a simpler foundation to come back to. That's why we'd begin with the Signature Ritual.";
      if (q5 === 'D') return "You told us you'd like a simple skincare foundation and you're happy to be guided on where to begin. That's why we'd begin with the Signature Ritual.";
      if (q3 === 'C' || q3 === 'D') return "You told us you'd like a simple skincare foundation you don't have to overthink, and you're ready to begin with the full-size ritual. That's why we'd begin with the Signature Ritual.";
      return "You told us you'd like a simple skincare foundation to come back to. That's why we'd begin with the Signature Ritual.";
    }
    return '';
  }

  function getMiniIntro(need, q4, q3, q2) {
    if (need === 'SOW') {
      if (q4 === 'A') return "You told us cleansing is the part of your routine you'd most like to change, and you'd prefer to begin with a smaller size to see how your skin feels. That's why we'd begin with Mini SOW.";
      return "You told us you're looking for a gentler cleanse, and you'd prefer to start small. That's why we'd begin with Mini SOW.";
    }
    if (need === 'CULTIVATE') return "You told us you're looking for more nourishment and softness, and you'd prefer to begin with a smaller size. That's why we'd begin with Mini CULTIVATE.";
    if (need === 'RITUAL') return "You told us you'd like a simpler skincare foundation, but you'd prefer to begin small and see how your skin feels. That's why we'd begin with Mini Mu.";
    return '';
  }

  // ── Q2 tiebreaker ─────────────────────────────────────────────────────────────
  function q2Tiebreak(q2, q1, q3) {
    if (q2 === 'B' || q2 === 'C' || q2 === 'D' || q2 === 'E') return 'SOW';
    if (q2 === 'A') {
      var q1Dry = q1.some(function (k) { return k === 'A' || k === 'D'; });
      return (q1Dry || q3 === 'B') ? 'CULTIVATE' : 'SOW';
    }
    return 'SOW';
  }

  // ── Core decision logic ───────────────────────────────────────────────────────
  function calculateResult() {
    var q1 = state.answers.q1, q2 = state.answers.q2, q3 = state.answers.q3,
        q4 = state.answers.q4, q5 = state.answers.q5;

    var need;
    if (q4 && Q4_NEED[q4]) {
      need = Q4_NEED[q4];
    } else {
      var scores = { SOW: 0, CULTIVATE: 0, RITUAL: 0 };
      q1.forEach(function (key) {
        var s = Q1_SCORES[key] || {};
        Object.keys(s).forEach(function (n) { scores[n] += s[n]; });
      });
      if (q2 && Q2_SCORES[q2]) Object.keys(Q2_SCORES[q2]).forEach(function (n) { scores[n] += Q2_SCORES[q2][n]; });
      if (q3 && Q3_SCORES[q3]) Object.keys(Q3_SCORES[q3]).forEach(function (n) { scores[n] += Q3_SCORES[q3][n]; });

      var max = Math.max(scores.SOW, scores.CULTIVATE, scores.RITUAL);
      var leaders = ['SOW', 'CULTIVATE', 'RITUAL'].filter(function (n) { return scores[n] === max; });

      if (leaders.length === 1) {
        need = leaders[0];
      } else if (leaders.indexOf('RITUAL') === -1) {
        need = q2Tiebreak(q2, q1, q3);
      } else if (leaders.length === 2) {
        need = leaders[0] === 'RITUAL' ? leaders[1] : leaders[0];
      } else {
        need = q2Tiebreak(q2, q1, q3);
      }
    }

    var startSmall = (q5 === 'A');
    var oneProduct = (q5 === 'C');
    var productKey;

    if (need === 'SOW') {
      productKey = startSmall ? 'MINI_SOW' : 'FULL_SOW';
    } else if (need === 'CULTIVATE') {
      productKey = startSmall ? 'MINI_CULTIVATE' : 'FULL_CULTIVATE';
    } else {
      if (startSmall) {
        productKey = 'MINI_MU';
      } else if (oneProduct) {
        var single = q2Tiebreak(q2, q1, q3);
        productKey = (single === 'CULTIVATE') ? 'FULL_CULTIVATE' : 'FULL_SOW';
      } else {
        productKey = 'SIGNATURE_RITUAL';
      }
    }

    state.result = productKey;
    return productKey;
  }

  // ── DOM helpers ───────────────────────────────────────────────────────────────
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function showStep(n) {
    qsa('.quiz-step').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
    var target = qs('[data-step="' + n + '"]');
    if (target) { target.hidden = false; target.setAttribute('aria-hidden', 'false'); }
    state.currentStep = n;
    updateProgress(n);
  }

  function updateProgress(n) {
    var bar = qs('.quiz-progress');
    if (!bar) return;
    if (n < 1 || n > 5) { bar.hidden = true; return; }
    bar.hidden = false;
    var label = qs('.quiz-progress-label');
    if (label) label.textContent = n + ' of 5';
    var fill = qs('.quiz-progress-fill');
    if (fill) fill.style.width = ((n / 5) * 100) + '%';
  }

  function validateStep(n) {
    if (n === 1) return state.answers.q1.length > 0;
    if (n === 2) return state.answers.q2 !== null;
    if (n === 3) return state.answers.q3 !== null;
    if (n === 4) return state.answers.q4 !== null;
    if (n === 5) return state.answers.q5 !== null;
    return true;
  }

  function showValidationError(n) {
    var step = qs('[data-step="' + n + '"]');
    if (!step) return;
    var err = qs('.quiz-error', step);
    if (!err) {
      err = document.createElement('p');
      err.className = 'quiz-error';
      err.setAttribute('role', 'alert');
      err.textContent = n === 1
        ? 'Please select at least one option before continuing.'
        : 'Please select an option before continuing.';
      var nav = qs('.quiz-nav', step);
      if (nav) step.insertBefore(err, nav);
    }
    err.hidden = false;
  }

  function clearValidationError(n) {
    var step = qs('[data-step="' + n + '"]');
    if (!step) return;
    var err = qs('.quiz-error', step);
    if (err) err.hidden = true;
  }

  // ── Result rendering ──────────────────────────────────────────────────────────
  function renderResult(productKey) {
    var resultStep = qs('[data-step="result"]');
    if (!resultStep) return;
    var q2 = state.answers.q2, q3 = state.answers.q3,
        q4 = state.answers.q4, q5 = state.answers.q5, q1 = state.answers.q1;
    var needMap = {
      FULL_SOW: 'SOW',      MINI_SOW: 'SOW',
      FULL_CULTIVATE: 'CULTIVATE', MINI_CULTIVATE: 'CULTIVATE',
      MINI_MU: 'RITUAL',    SIGNATURE_RITUAL: 'RITUAL'
    };
    var need = needMap[productKey];
    var isMini = productKey === 'MINI_SOW' || productKey === 'MINI_CULTIVATE' || productKey === 'MINI_MU';
    var intro = isMini
      ? getMiniIntro(need, q4, q3, q2)
      : getPersonalisedIntro(need, q4, q3, q2, q5);
    var introEl = qs('[data-result-intro]', resultStep);
    if (introEl) introEl.textContent = intro;
    qsa('[data-product-result]', resultStep).forEach(function (el) {
      el.hidden = el.dataset.productResult !== productKey;
    });
    showStep('result');
  }

  // ── Quiz navigation ───────────────────────────────────────────────────────────
  function initQuiz() {
    var quiz = qs('#huxmu-quiz');
    if (!quiz) return;

    var startBtn = qs('[data-quiz-start]', quiz);
    if (startBtn) { startBtn.addEventListener('click', function () { showStep(1); }); }

    var q1Step = qs('[data-step="1"]', quiz);
    if (q1Step) {
      qsa('[data-answer]', q1Step).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.answer;
          var idx = state.answers.q1.indexOf(key);
          if (idx === -1) {
            state.answers.q1.push(key);
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          } else {
            state.answers.q1.splice(idx, 1);
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-pressed', 'false');
          }
          clearValidationError(1);
        });
      });
    }

    [2, 3, 4, 5].forEach(function (n) {
      var step = qs('[data-step="' + n + '"]', quiz);
      if (!step) return;
      qsa('[data-answer]', step).forEach(function (btn) {
        btn.addEventListener('click', function () {
          qsa('[data-answer]', step).forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.answers['q' + n] = btn.dataset.answer;
          clearValidationError(n);
        });
      });
    });

    qsa('[data-quiz-next]', quiz).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.quizNext, 10);
        if (!validateStep(step)) { showValidationError(step); return; }
        if (step === 5) { renderResult(calculateResult()); }
        else { showStep(step + 1); }
      });
    });

    qsa('[data-quiz-back]', quiz).forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(parseInt(btn.dataset.quizBack, 10) - 1);
      });
    });

    qsa('[data-quiz-restart]', quiz).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.answers = { q1: [], q2: null, q3: null, q4: null, q5: null };
        state.result = null;
        qsa('[data-answer]', quiz).forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        showStep(0);
      });
    });

    showStep(0);
  }

  // ── Boot ──────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }

})();
